// Common salary amounts for which we want to generate SEO-optimized pages
export const commonSalaries = [
  20000, 22000, 25000, 27000, 30000, 32000, 35000, 37000, 40000, 42000, 
  45000, 47000, 50000, 52000, 55000, 57000, 60000, 62000, 65000, 67000,
  70000, 72000, 75000, 77000, 80000, 85000, 90000, 95000, 100000
];

// Generate URL slug from salary amount
export const generateSalaryUrl = (salary) => {
  return `${salary}-after-tax-uk`;
};

// Extract salary from URL slug
export const extractSalaryFromUrl = (urlSlug) => {
  const match = urlSlug.match(/^(\d+)-after-tax-uk$/);
  return match ? parseInt(match[1], 10) : null;
};

// Check if a URL slug is a valid salary route
export const isValidSalaryRoute = (urlSlug) => {
  const salary = extractSalaryFromUrl(urlSlug);
  return salary !== null && salary >= 10000 && salary <= 500000;
};